module.exports = __webpack_public_path__ + "media/tags/mass-2-3fd8fa04.png";